import React, {useEffect, useState} from "react";
import {Button, Modal, notification} from "antd";
import SelectField from "../../select-field";
import Spinner from "../../spinner";
import i18n from "../../../i18n";
import {distributionCenterService, approveOrderService} from "../../../services";

export default function ModalChangeApproveOrderDC({isShow, setIsShow, orderId, setIsNeedUpdate}) {
  const [loading, setLoading] = useState(false);
  const [dcList, setDcList] = useState([]);
  const [selectedDC, setSelectedDC] = useState(null);
  const [isDisabled, setIsDisabled] = useState(false);

  useEffect(() => {
    if (isShow) {
      setLoading(true);
      setSelectedDC(null);
      distributionCenterService.getCompanies(true)
        .then(res => {
          setDcList(res);
          setLoading(false);
        })
        .catch(err => {
          notification.error({
            message: i18n.t('components.notification.titles.error'),
            description: err
          });
          setLoading(false);
        });
    }
  }, [isShow]);

  const submitBtnStyle = {
    width: "200px",
    height: "43px",
    background: "#1CAA53",
    position: "static",
    borderRadius: "10px",
    color: "white",
    borderColor: "transparent",
  };

  const onSignUp = () => {
    setIsDisabled(true);
    approveOrderService.changeDistributionCenter(orderId, selectedDC)
      .then((response) => {
        notification.success({
          message: i18n.t('components.notification.titles.changeApproveOrderDC'), description: response.message,
        });
        setIsShow(false);
        setIsNeedUpdate(true);
      })
      .catch((err) => {
        notification.error({
          message: i18n.t('components.notification.titles.changeApproveOrderDC'), description: err,
        });
      })
      .finally(() => {
        setIsDisabled(false);
      })
  }

  return (
    <Modal
      title={<div>{i18n.t('modals.modalChangeApproveOrderDC.title')}</div>}
      cancelText={i18n.t('main.buttons.close')}
      className="modal-window"
      align={null}
      visible={isShow}
      onCancel={() => {
        setIsShow(false);
      }}
      forceRender={true}
      footer={
        <Button htmlType="submit" key="submit" type="primary"
                style={submitBtnStyle}
                onClick={() => onSignUp()}
                disabled={selectedDC === null || isDisabled}
        >{i18n.t('main.buttons.send')}</Button>
      }
    >
      <Spinner loading={loading} tip={i18n.t('main.loadText.loading')}>
        <SelectField
          title={i18n.t('modals.modalChangeApproveOrderDC.fields.distributionCenter.title')}
          name="distributionCenter"
          selectedValue={selectedDC}
          values={dcList}
          onChange={(value) => {
            setSelectedDC(value);
          }}
          getErrors={() => {
          }}
          placeholder={i18n.t('modals.modalChangeApproveOrderDC.fields.distributionCenter.placeholder')}
          notFoundText={i18n.t('modals.modalChangeApproveOrderDC.fields.distributionCenter.notFoundText')}
          showArrow={true}
          style={{width: "100%"}}
        />
      </Spinner>
    </Modal>
  )
}